import React, { Component } from 'react';
import style from './ChapterSectionQuote.module.scss';
import { TweenLite } from 'gsap';
import ScreenedImageCover from '../ui/ScreenedImageCover';
import Quote from '../tour/assets/QuotationMark_Red';

class ChapterSectionQuote extends Component {
  componentDidMount() {
    this.props.setActiveImage(
      this.props.index,
      this.props.sectionData.image.sizes.large
    );
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.preExit !== nextProps.preExit && nextProps.preExit) {
      this.preDrawExit();
    }
    if (
      this.props.exitingDrawn !== nextProps.exitingDrawn &&
      nextProps.exitingDrawn
    ) {
      this.postDrawExit();
    }
  }
  preDrawExit() {
    TweenLite.to(this.contentEl, 0.5, {
      opacity: 0,
      x: 0,
    });
  }
  postDrawExit() {
    this.bk.style.visibility = 'hidden';
  }
  render() {
    return (
      <div
        className={`section ${style.sectionWrapper} ${
          this.props.isFirst ? style.firstSection : ''
        }`}
      >
        <div
          className={style.bkWrap}
          ref={el => {
            this.bk = el;
          }}
        >
          <ScreenedImageCover
            url={this.props.sectionData.image.sizes.large}
            load={this.props.display}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={style.quote}>
            <div
              ref={el => {
                this.contentEl = el;
              }}
            >
              <div className={`chapter-quote ${style.quoteMark}`}>
                <Quote />
              </div>
              <h4
                dangerouslySetInnerHTML={{
                  __html: this.props.sectionData.quote_text,
                }}
              />
              <p className={style.attribution}>
                &ndash; {this.props.sectionData.caption}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChapterSectionQuote;



// WEBPACK FOOTER //
// ./src/components/chapter/ChapterSectionQuote.js